import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useUserContext } from "../providers/userProvider";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import logo from "../../assets/logo.png";

export const LoginPage: FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | undefined>();

  const { user, signup, signin } = useUserContext();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    if (user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const onSignup = async () => {
    const result = await signup(email, password);

    if (result.error) {
      console.error(result.error);
      setError(result.error);
    }
    if (result.user) {
      navigate("/");
    }
  };

  const onSignin = async () => {
    const result = await signin(email, password);

    if (result.error) {
      console.error(result.error);
      setError(result.error);
    }
    if (result.user) {
      navigate("/");
    }
  };

  return (
    <Box
      height={"100vh"}
      display={"flex"}
      flexDirection={"column"}
      width={1}
      sx={{
        background:
          "linear-gradient(34deg, rgba(242,246,255,1) 0%, rgba(194,194,246,1) 50%, rgba(212,219,230,1) 100%);",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        flexGrow={1}
        p={2}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          p={5}
          width={1}
          maxWidth={350}
          borderRadius={4}
          sx={{ background: "white" }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width={1}
          >
            <Box
              display="flex"
              flexDirection="column"
              maxWidth="500px"
              width={1}
              padding={2}
              gap={2}
            >
              <Box
                component="img"
                src={logo}
                alt={"Logo"}
                width={250}
                height={100}
                mb={2}
                alignSelf={"center"}
              />
              <Typography variant="h4" alignSelf={"center"}>
                Login
              </Typography>

              {error && <Typography color="error">{error}</Typography>}

              <TextField
                variant="outlined"
                label="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />

              <TextField
                variant="outlined"
                label="Password"
                value={password}
                type={showPassword ? "text" : "password"}
                onChange={(event) => setPassword(event.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={onSignin}
              >
                Sign in
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
